import { Params } from '@angular/router';
import { SidebarTabs } from '../../model/sidebar.model';
import { NumberSerializerBase } from './base/number.base';
import {
  QueryParamSerializer,
  QueryParamsKeys,
} from '../model/sidebar-query-params.model';

export class ActiveTabSerializer
  extends NumberSerializerBase
  implements QueryParamSerializer<SidebarTabs>
{
  public readonly key = QueryParamsKeys.sidebarActiveTab;

  keyIsIn(params: Params): boolean {
    return Object.hasOwn(params, this.key);
  }

  deserializeQueryParamValue(value: string): SidebarTabs {
    return this.deserialize(value);
  }

  serializeToQueryParamValue(value: SidebarTabs): string {
    return this.serialize(value);
  }
}
